<template>
  <div class="standard-user-level-toggle">
    <v-btn-toggle v-model="showLevelsList" light mandatory class="standard-user-level-select-group mx-0 " >
      <!-- Show button with short text and no icon on sm devices -->
      <v-btn v-if="breakpoint.smAndDown" flat depressed class="standard-user-level-button" value="standard">
        Standard
      </v-btn>
      <!-- Else show the full shebang -->
      <v-btn v-else flat depressed class="standard-user-level-button" value="standard">
        <v-icon left>star</v-icon>
        Standard Exercises
      </v-btn>
     
      <v-btn v-if="breakpoint.smAndDown" flat class="standard-user-level-button" value="user">
          User
      </v-btn>
    
      <v-btn  v-else flat class="standard-user-level-button" value="user">
        <v-icon left>supervisor_account</v-icon>
          User Exercises
      </v-btn>
     

    </v-btn-toggle>
  </div>
  
</template>

<script>
export default {
  name: 'standardUserLevelToggle',
  data() {
    return {
      showLevelsList: this.$store.getters.getShowLevels 
    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },
  watch: {
    showLevelsList() {
      this.$store.dispatch('setShowLevels', this.showLevelsList);
    }
  }
}
</script>

<style>
.standard-user-level-toggle .v-btn--active {
  border-bottom: 3px solid teal
;
}
.standard-user-level-toggle  .standard-user-level-select-group {
  width: 100%;
}
.standard-user-level-toggle .standard-user-level-button {
  width: 50%;
}

</style>
